import React, { useEffect, useState, lazy, Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AOS from "aos";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollProgress from "./ui/ScrollProgress";

// Pulls in react-simple-chatbot + styled-components; not needed for first
// paint on any page. Lazy-loaded AND mount-delayed (see showChatbot below)
// so its chunk isn't even requested until the page has settled.
const Chatbot = lazy(() => import("./pages/Chatbot"));

const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    AOS.init({
      once: false,
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const [shouldNavbarstick, setshouldNavbarstick] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const shouldAddClasses = window.scrollY > 100;
      setshouldNavbarstick(shouldAddClasses);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const navClasses = `fixed-top d-flex align-items-center  ${
    shouldNavbarstick ? "header-scrolled" : ""
  }`;

  const [showChatbot, setShowChatbot] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShowChatbot(true), 2000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <ScrollProgress key={pathname} />
      <Navbar navClasses={navClasses} />
      <Outlet />
      <Footer />
      {showChatbot && (
        <Suspense fallback={null}>
          <Chatbot />
        </Suspense>
      )}
    </>
  );
};

export default Layout;
